module.exports = __webpack_public_path__ + "img/arrow-next.51987cb9.svg";